// ======================================================================
// File Name       : SuperUserDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import $ from 'jquery';
import { Form, Col } from 'react-bootstrap';
import { getItemBoxName } from '../../utils/index';
import { getEnterprisePath, getSuperUserType } from '../../utils/EnterPriseUtils';
import { MODE } from '../../constants/index';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';

function SuperUserDetail({
  mode,
  isCheck,
  superuserDetail,
  enterpriseInfo,
  enterpriseList,
  allServiceCdRoleList,
  superuserRoleList,
  superuserAllServiceRoleList,
  allServiceRelation,
  superuserAllEnterpriseRoleList,
  detailServiceGroupNameList, // STEP10.0.0
  serviceCdListSorted,
  showLoginIdPasswordSendFlag,
}) {
  let serviceRoleList = null;
  let superuserRelationServiceGroupList = null;
  if (isCheck) { // on confirm page
    serviceRoleList = serviceCdListSorted && serviceCdListSorted.map((cur, index) => {
      const superuserServiceRoleSecernId = allServiceCdRoleList[cur];
      const roleData = superuserAllServiceRoleList &&
        superuserAllServiceRoleList.bySecernId &&
        superuserAllServiceRoleList.bySecernId[superuserServiceRoleSecernId];
      const { serviceName } = allServiceRelation && allServiceRelation[cur];
      return (
        <Col sm={12} key={index} className="margin-top-10 padding-left-right-clear">
          <Col sm={5} className="padding-left-50 padding-top-bottom-10 padding-right-10">{serviceName}</Col>
          <Col sm={7} className="padding-top-bottom-10 padding-left-right-clear">
            {roleData && roleData.superuserServiceRoleName}
          </Col>
        </Col>
      );
    });
  } else { // on detail page
    serviceRoleList = superuserRoleList && Object.keys(superuserRoleList.roleList).map((cur, index) => {
      const { serviceName, superuserServiceRoleName } = superuserRoleList.roleList[cur];
      return (
        <Col sm={12} key={index} className="margin-top-10 padding-left-right-clear">
          <Col sm={5} className="padding-left-50 padding-top-bottom-10 padding-right-10">{serviceName}</Col>
          <Col sm={7} className="padding-top-bottom-10 padding-left-right-clear">
            {superuserServiceRoleName}
          </Col>
        </Col>
      );
    });
    // STEP10.0.0 START
    superuserRelationServiceGroupList =
      detailServiceGroupNameList &&
      Object.keys(detailServiceGroupNameList).map((serviceGroupSecernId, index) => (
        <Col
          sm={12}
          key={index}
          className="margin-top-10 padding-left-right-clear"
        >
          <Col sm={5} className="form-label">
            所属サービスグループ{index + 1}
          </Col>
          <Col sm={7} className="margin-top-10 padding-left-right-clear">
            {detailServiceGroupNameList[serviceGroupSecernId]}
          </Col>
        </Col>
      ));
    // STEP10.0.0 END
  }

  const isShowRoleList =
    serviceRoleList &&
    Object.keys(serviceRoleList).length > 0 &&
    superuserAllServiceRoleList &&
    Object.keys(superuserAllServiceRoleList.roleList).length > 0;

  const superuserEnterpriseRoleName =
    superuserDetail &&
    superuserDetail.superuserEnterpriseRoleSecernId &&
    superuserAllEnterpriseRoleList &&
    superuserAllEnterpriseRoleList.bySecernId &&
    superuserAllEnterpriseRoleList.bySecernId[superuserDetail.superuserEnterpriseRoleSecernId] &&
    superuserAllEnterpriseRoleList.bySecernId[superuserDetail.superuserEnterpriseRoleSecernId].superuserEnterpriseRoleName;

  if (superuserDetail === undefined || Object.keys(superuserDetail).length === 0) {
    return null;
  }

  return (
    <Form className='form-horizontal'>
      <Form.Group className="form-info" controlId="formHorizontalSuperUserName">
        <Col sm={5} className="form-label">
          SuperUser名
        </Col>
        <Col sm={7} className="lable-value padding-top-bottom-10">
          {superuserDetail.superuserName}
        </Col>
      </Form.Group>

      <Form.Group className="form-info " controlId="formHorizontalLoginID">
        <Col sm={5} className="form-label">
          ログインID
        </Col>
        <Col sm={7} className="lable-value padding-top-bottom-10">
          {superuserDetail.loginId}
        </Col>
      </Form.Group>

      <Form.Group className="form-info" controlId="formHorizontalPassword">
        <Col sm={5} className="form-label">
          パスワード
        </Col>
        <Col sm={7} className="lable-value padding-top-bottom-10">
          {superuserDetail.password && Array(superuserDetail.password.length + 1).join('•')}
        </Col>
      </Form.Group>

      {/* Step10.0.0 START */}
      {!isCheck && (
        <Form.Group className="form-info" controlId="formHorizontalCompany">
          <Col sm={5} className="form-label">
            所属企業
          </Col>
          <Col sm={7} className="lable-value padding-top-bottom-10">
            {getEnterprisePath(superuserDetail, enterpriseList)}&nbsp; ({enterpriseInfo.byCd[
              superuserDetail.enterpriseCd
            ] &&
              superuserDetail.enterpriseCd &&
              getItemBoxName(
                SELECT_BOX_DATA.DORMANT_STATE,
                enterpriseInfo.byCd[superuserDetail.enterpriseCd].dormantState,
              )})
          </Col>
        </Form.Group>
      )}
      <Form.Group className="form-info" controlId="formHorizontalRole">
        <Col sm={5} className="form-label">
          企業ロール
        </Col>
        <Col sm={7} className="lable-value padding-top-bottom-10">
          {superuserEnterpriseRoleName}
        </Col>
      </Form.Group>
      {isShowRoleList && (
        <Form.Group className="form-info" controlId="formHorizontalRole">
          <Col sm={12} className="form-label">
            サービスロール
          </Col>
          <Col sm={12} className="lable-value padding-top-bottom-10">
            {serviceRoleList}
          </Col>
        </Form.Group>
      )}
      {/* Step10.0.0 END */}
      <Form.Group className="form-info" controlId="formHorizontalEmail">
        <Col sm={5} className="form-label">
          メールアドレス
        </Col>
        <Col sm={7} className="lable-value padding-top-bottom-10">
          {superuserDetail.mailAddress}
        </Col>
      </Form.Group>
      {/* Step10.0.0 START */}
      {!isCheck &&
        detailServiceGroupNameList &&
        Object.keys(detailServiceGroupNameList).length > 0 && (
          <Form.Group className="form-info" controlId="formHorizontalEmail">
            <Col sm={12} className="lable-value padding-top-bottom-10">
              {superuserRelationServiceGroupList}
            </Col>
          </Form.Group>
      )}
      {/* Step10.0.0 END */}

      <Form.Group className="form-info" controlId="formHorizontalReMark">
        <Col sm={5} className="form-label">
          備考
        </Col>
        <Col sm={7} className="lable-value padding-top-bottom-10">
          {superuserDetail.remark}
        </Col>
      </Form.Group>
      {/* Step10.0.0 START */}
      {mode !== MODE.NEW_MODE && !isCheck && (
        <Form.Group className="form-info" controlId="formHorizontalRootFlag">
          <Col sm={5} className="form-label">
            ユーザー種別
          </Col>
          <Col sm={7} className="lable-value padding-top-bottom-10">
            {getSuperUserType(superuserDetail.rootFlag)}
          </Col>
        </Form.Group>
      )}
      {/* Step10.0.0 END */}
      {mode !== MODE.NEW_MODE && (
        <Form.Group className="form-info" controlId="formHorizontalStatus">
          <Col className="form-label" sm={5}>
            ロック状態
          </Col>
          <Col className="lable-value padding-top-bottom-10" sm={7}>
            {!isCheck && getItemBoxName(SELECT_BOX_DATA.LOCK_TYPE, superuserDetail.lockState)}
            {isCheck && getItemBoxName(SELECT_BOX_DATA.LOCK_TYPE, superuserDetail.isUnlock ? 0 : 1)}
          </Col>
        </Form.Group>)}
      <Form.Group className="form-info">
        <Col sm={10} className="form-label">
          <Form.Check
            type='checkbox'
            name="passwordChangeFlag"
            id="passwordChangeFlagDetail"
            disabled
            checked={superuserDetail.passwordChangeFlag}
            label='次回ログイン時にパスワード変更'></Form.Check>
        </Col>
      </Form.Group>
      {/* sprint_20230418 #12 START */}
      <Form.Group className="form-info">
        <Col sm={10} className="form-label">
          <Form.Check
            type='checkbox'
            name="readOnlyFlag"
            id="readOnlyFlagDetail"
            disabled
            checked={superuserDetail.readOnlyFlag}
            label='読み取り専用'></Form.Check>
        </Col>
      </Form.Group>
      {/* Step 10.1.0 START */}
      { showLoginIdPasswordSendFlag &&
      <Form.Group className="form-info">
        <Col sm={12} className="form-label">
          <Form.Check
            type='checkbox'
            className="cursor-default"
            name="loginIdPasswordSendFlag"
            id="loginIdPasswordSendFlagDetail"
            disabled
            checked={superuserDetail.loginIdPasswordSendFlag === 1}
            label='ログインID、パスワードをメールで送信する'></Form.Check>
        </Col>
      </Form.Group>
      }
      {/* Step 10.1.0 END */}
      {/* sprint_20230418 #12 END */}
    </Form>
  );
}
export default SuperUserDetail;
